// src/redux/slices/menuItemDetailsSlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

// Type definitions (moved from deleted plugin file)
export interface ModifierOption {
  id: string;
  name: string;
  price: string;
  image: string | null;
  isEnabled: boolean;
  modifiers: any | null;
}

export interface Modifier {
  id: string;
  name: string;
  isRequired: boolean;
  allowMultiples: boolean;
  minRequired: number;
  maxAllowed: number;
  sortOrder: number;
  options: ModifierOption[];
}

export interface Category {
  id: string;
  name: string;
  image: string | null;
  restaurantId: string;
  isActive: boolean;
  sortOrder: number;
  posReferenceId: string;
  description: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface MenuItemDetails {
  id: string;
  restaurantId: string;
  name: string;
  description: string | null;
  price: {
    dining: number;
    online: number;
  };
  categoryId: string;
  subCategoryId: string | null;
  imageUrl: string | null;
  posReferenceId: string;
  foodType: string | null;
  meta: any | null;
  mealTime: string | null;
  modifiers: string[];
  inventoryStatus: boolean;
  isItemVerified: boolean;
  isDeleted: boolean;
  createdAt: string;
  updatedAt: string;
}

interface MenuItemDetailsState {
  item: MenuItemDetails | null;
  categories: Category[];
  modifiers: Modifier[];
  loading: boolean;
  error: string | null;
}

const initialState: MenuItemDetailsState = {
  item: null,
  categories: [],
  modifiers: [],
  loading: false,
  error: null,
};

export const menuItemDetailsSlice = createSlice({
  name: 'menuItemDetails',
  initialState,
  reducers: {
    // Fetch menu item details actions
    fetchMenuItemDetailsRequest: (state, action: PayloadAction<string>) => {
      state.loading = true;
      state.error = null;
    },
    fetchMenuItemDetailsSuccess: (
      state,
      action: PayloadAction<{
        items: MenuItemDetails[];
        categories: Category[];
        modifiers: Modifier[];
      }>
    ) => {
      state.loading = false;
      state.item = action.payload.items[0] || null;
      state.categories = action.payload.categories;
      state.modifiers = action.payload.modifiers;
      state.error = null;
    },
    fetchMenuItemDetailsFailure: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
      state.item = null;
      state.categories = [];
      state.modifiers = [];
    },

    // Clear menu item details
    clearMenuItemDetails: state => {
      state.item = null;
      state.categories = [];
      state.modifiers = [];
      state.error = null;
      state.loading = false;
    },
  },
});

export const {
  fetchMenuItemDetailsRequest,
  fetchMenuItemDetailsSuccess,
  fetchMenuItemDetailsFailure,
  clearMenuItemDetails,
} = menuItemDetailsSlice.actions;

export default menuItemDetailsSlice.reducer;
